export default "__VITE_ASSET__ghl4eEg5__"